import React, { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import Preloader from '../components/Preloader/Preloader'

const HomePage = React.lazy(() => import('../components/HomePage/HomePage'))
const Cart = React.lazy(() => import('../components/Cart/Cart'))
const SingleProduct = React.lazy(() => import('../components/Products/SingleProduct'))
const SingleCategory = React.lazy(() => import('../components/Categories/SingleCategory'))
const Checkout = React.lazy(() => import('../components/Checkout/Checkout'))
const AdminPanel = React.lazy(() => import('../components/AdminPanel/AdminPanel'))
const SearchResults = React.lazy(() => import('../components/Search/SearchResults'))
const Favorites = React.lazy(() => import('../components/Favorites/Favorites'))
const UserOrders = React.lazy(() => import('../components/UserOrders/UserOrders'))
const Profile = React.lazy(() => import('../components/Profile/Profile'))
const DeliveryPage = React.lazy(() => import('../components/InfoPage/DeliveryPage'))
const PaymentPage = React.lazy(() => import('../components/InfoPage/PaymentPage'))
const NotFound = React.lazy(() => import('../components/NotFound/NotFound'))

const RouteFallback = () => <Preloader message="Завантаження…" />

const AppRoutes = () => (
  <Suspense fallback={<RouteFallback />}>
    <Routes>
      <Route index path='/' element={<HomePage />} />
      <Route path='/profile' element={<Profile />} />
      <Route path='/favorites' element={<Favorites />} />
      <Route path='/orders' element={<UserOrders />} />
      <Route path='/products/:slugOrId' element={<SingleProduct />} />
      <Route path='/categories/:slugOrId' element={<SingleCategory />} />
      <Route path='/cart' element={<Cart />} />
      <Route path='/checkout' element={<Checkout />} />
      <Route path='/search' element={<SearchResults />} />
      <Route path='/delivery' element={<DeliveryPage />} />
      <Route path='/payment' element={<PaymentPage />} />
      <Route path='/admin' element={<AdminPanel />} />
      <Route path='*' element={<NotFound />} />
    </Routes>
  </Suspense>
)

export default AppRoutes;
